import { useBadgingTranslation } from '../../../../../ui/hooks';
import { EmptyContentWrapper } from '@juvare/common-web-ui/EmptyContentWrapper';
import { organizationEntityName } from '@juvare/contact-management/backend/features/organizations/shared';
import { useStorageList } from '@juvare/platform-sdk-react/ui/hooks';
import { Box, CircularProgress } from '@mui/material';
import React, { useMemo } from 'react';
import { AccountBadgeUserViewTableRow } from './AccountBadgeUserViewTableRow';
export const AccountBadgeUserViewTableContent = ({ rows, onActionSuccess, AccountBadgeSlideoutComponent, loading, reload, }) => {
    const { t } = useBadgingTranslation();
    const organizationIds = [...new Set(rows.flatMap((r) => (r.columns.organizationId ? r.columns.organizationId : [])))];
    const { data: organizations } = useStorageList(organizationEntityName, {
        filter: [{ id: organizationIds, op: 'in' }],
    });
    const organizationMap = useMemo(() => {
        var _a;
        return (_a = organizations === null || organizations === void 0 ? void 0 : organizations.rows.reduce((sum, org) => {
            sum[org.id] = org;
            return sum;
        }, {})) !== null && _a !== void 0 ? _a : {};
    }, [organizations === null || organizations === void 0 ? void 0 : organizations.rows]);
    const [selectedRowId, setSelectedRowId] = React.useState(undefined);
    const handleRowClick = AccountBadgeSlideoutComponent
        ? (row) => {
            setSelectedRowId(row.id);
        }
        : undefined;
    const reloadRows = () => {
        reload();
        setSelectedRowId(undefined);
    };
    return (React.createElement(Box, { sx: {
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'start',
            gap: 2,
        } },
        loading && rows.length === 0 ? (React.createElement(CircularProgress, null)) : rows.length === 0 ? (React.createElement(EmptyContentWrapper, { description: t('accountBadgeSection.accountBadgesTable.tableEmpty') })) : (React.createElement(React.Fragment, null, rows.map((row) => {
            return (React.createElement(AccountBadgeUserViewTableRow, { key: row.id, row: row, organizationMap: organizationMap, onActionSuccess: onActionSuccess, onRowClick: handleRowClick }));
        }))),
        AccountBadgeSlideoutComponent && (React.createElement(AccountBadgeSlideoutComponent, { accountBadgeId: selectedRowId !== null && selectedRowId !== void 0 ? selectedRowId : '', refetchAccountBadgeList: reloadRows, onClose: (changed) => {
                setSelectedRowId(undefined);
                if (changed) {
                    reloadRows();
                }
            } }))));
};
